import { LogoutOutlined, ShopOutlined, UserAddOutlined } from '@ant-design/icons'
import { Button, Col, Row, Tooltip } from 'antd'
import { MyTheme } from 'Components/common/Theme'
import { getUserLogin } from 'helpers/account'
import React from 'react'
import { useDispatch } from 'react-redux'
import { logoutAction } from 'Store/user/actions'
import styled from 'styled-components'

type Props = {
  active?: string
  history: any
  bgColor?: string
}

const HomePageMenu = (props: Props) => {
  const { active, history, bgColor = 'transparent' } = props
  const userInfo = getUserLogin()
  const isMerchant = userInfo && userInfo?.store_type === 'merchant'

  const configMenu = [
    {
      name: 'ร้านค้าของฉัน',
      to: '/mymerchants',
      icon: <ShopOutlined />,
      subMenu: [],
      key: 'mymerchants',
    },
    {
      name: 'ตั้งค่าผู้ใช้งาน',
      to: '/manage-user',
      icon: <UserAddOutlined />,
      subMenu: [],
      key: 'manage-user',
    },
    {
      name: 'ออกจากระบบ',
      to: '/',
      icon: <LogoutOutlined />,
      subMenu: [],
      key: 'logout',
    },
  ]

  const configStaffMenu = [
    {
      name: 'ออกจากระบบ',
      to: '/',
      icon: <LogoutOutlined />,
      subMenu: [],
      key: 'logout',
    },
  ]

  const dispatch = useDispatch()

  const onLogout = (): void => {
    dispatch(logoutAction())
  }

  const gotoPage = (link: string): void => {
    history(link)
  }

  const topMenu = isMerchant ? configMenu : configStaffMenu

  return (
    <Wrapper style={{ background: bgColor }}>
      <Row justify="end" gutter={[3, 16]}>
        {topMenu.map((item, index) => {
          const isActive = active === item.key
          return (
            <Col key={index}>
              {item.key === 'logout' ? (
                <Tooltip title={item.name}>
                  <Button
                    shape="circle"
                    className={'inactive'}
                    type={'primary'}
                    icon={item.icon}
                    onClick={onLogout}
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip title={item.name}>
                  <Button
                    onClick={() => gotoPage(item.to)}
                    shape="round"
                    className={isActive ? 'active' : 'inactive'}
                    type={'primary'}
                    icon={item.icon}
                  >
                    {item.name}
                  </Button>
                </Tooltip>
              )}
            </Col>
          )
        })}
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 10px 20px 10px 0;
  .anticon {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  }

  .inactive.ant-btn-primary {
    background: rgba(0, 0, 0, 0.018);
    border: none;
    box-shadow: none;
  }

  .active .anticon,
  .active span {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  }
  .active.ant-btn-primary {
    background: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
    box-shadow: none;
  }
`

export default HomePageMenu
